import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { PlanList } from "@/components/features/items/list/plan/ui/components/root";

import { useGetRoomListPageParams } from "../../room/list/_hooks/use-get-room-list-page-params";

export const PlanListPage = () => {
	const { hotelID } = useGetRoomListPageParams();

	return (
		<PageMeta title="プランの一覧" url={generatePath(PATHS.HOTEL.ITEMS.PLAN.TOP, { hotelID })}>
			<PlanList hotelID={hotelID} />
		</PageMeta>
	);
};

PlanListPage.displayName = "PlanListPage";
